import type { TransportOrderDetail } from 'api/generated/transportOrdersApi';
import { useListHubsQuery } from 'api/hubsApi';
import TransportOrderDialog from 'components/TransportOrderDialog';
import { useEffect, useState } from 'react';

import TransportOrderForm from './TransportOrderForm';
import { initialFormValues, isFormValid, type TransportOrderFormType } from './transportOrderFormModel';

export type TransportOrderFormDialogProps = {
    show: boolean;
    transportOrder?: TransportOrderDetail;
    onClose: () => void;
    onSubmit: (values: TransportOrderFormType) => void;
};

const TransportOrderFormDialog = ({ show, transportOrder, onClose, onSubmit }: TransportOrderFormDialogProps) => {
    const { data: hubs = [] } = useListHubsQuery();
    const hubOptions = hubs.map(hub => ({ id: hub.id, label: hub.name }));
    const [formValues, setFormValues] = useState<TransportOrderFormType>(() => initialFormValues(transportOrder));

    const editedOrderId = transportOrder?.transportOrderId;

    useEffect(() => {
        if (show) {
            setFormValues(initialFormValues(transportOrder));
        }
    }, [show, editedOrderId]);

    const mode = transportOrder === undefined ? 'create' : 'edit';
    const canSubmit = isFormValid(formValues);

    const confirm = () => {
        if (isFormValid(formValues)) {
            onSubmit(formValues);
        }
    };

    return (
        <TransportOrderDialog show={show} mode={mode} disableConfirm={!canSubmit} onClose={onClose} onConfirm={confirm}>
            <TransportOrderForm
                values={formValues}
                onChange={setFormValues}
                launchHubOptions={hubOptions}
                landingHubOptions={hubOptions}
                excludeTransportOrderId={transportOrder?.transportOrderId}
            />
        </TransportOrderDialog>
    );
};

export default TransportOrderFormDialog;
